import { db } from "../firebase";
import {
  collection,
  addDoc,
  query,
  orderBy,
  serverTimestamp,
  onSnapshot
} from "firebase/firestore";

export const addLog = async ({ action, detail, userEmail }) => {
  return addDoc(collection(db, "activityLogs"), {
    action,
    detail,
    userEmail: userEmail || "Bilinmeyen Kullanıcı",
    createdAt: serverTimestamp()
  });
};

export const subscribeActivityLogs = (callback) => {
  const q = query(
    collection(db, "activityLogs"),
    orderBy("createdAt", "desc")
  );

  return onSnapshot(q, (snapshot) => {
    const data = snapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data()
    }));

    callback(data);
  });
};